import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useStoreContext = () => useSelector(store, (state) => state.context);
